const home = {
  heroTitle: '吃瓜视频',
  heroSubtitle: '网红黑料实时追踪 · 明星八卦每日更新',
  heroCTA: '开始吃瓜',
  hotSectionTitle: '🔥 最新猛料',
  categorySectionTitle: '分类浏览',
  aboutSectionTag: '关于平台',
  aboutSectionTitle: '🍉 你身边的吃瓜第一站',
  reviewSectionTitle: '吃瓜群众热评',
  ctaSectionTitle: '不错过任何一个大瓜',
  ctaSectionSubtitle: '每日更新 · 实时追踪 · 高清流畅',
  ctaButton: '立即开始吃瓜',
  statVideos: '视频总量',
  statUsers: '活跃用户',
  statDaily: '日访问量',
  statUpdate: '更新频率',
  views: '次播放',
  updatedAgo: '前更新',
};

export default home;